import * as types from '@/store/configuration/actionTypes';
import {
  CLEAR_TOP_LEVEL_DOMAINS,
  CLEAR_TOP_LEVEL_DOMAINS_ASSETS,
  SET_DOWNLOAD_REPORT_DISABLE,
  SET_SUCCESS_OPERATION_MESSAGE,
  SET_TOP_LEVEL_DOMAIN_LIST_OPTIONS,
  SET_TOP_LEVEL_DOMAINS,
  SET_TOP_LEVEL_DOMAINS_ASSETS,
  SET_INFRASTRUCTURE_LIST_OPTIONS,
  CLEAR_INFRASTRUCTURE,
  SET_INFRASTRUCTURE,
  SET_PORT_OPTIONS,
  CLEAR_PORT_OPTIONS,
  CLEAR_WAF_OPTIONS,
  CLEAR_SERVICES_OPTIONS,
  SET_WAF_OPTIONS,
  SET_SERVICES_OPTIONS,
  SET_LOCATION_OPTIONS,
  CLEAR_LOCATION_OPTIONS,
  SET_COORDINATES_OPTIONS,
  CLEAR_COORDINATES_OPTIONS,
  SET_LEAKS_LIST_OPTIONS,
  SET_LEAKS,
  CLEAR_LEAKS,
  SET_TLDS_WITH_NO_LEAKS_SCAN,
  SET_TLDS_WITH_LEAKS_SCAN,
  SET_LEAKS_SOURCE_OPTIONS,
  SET_LEAKS_TYPE_OPTIONS,
  CLEAR_TLDS_WITH_NO_LEAKS_SCAN,
  CLEAR_TLDS_WITH_LEAKS_SCAN,
  CLEAR_LEAKS_SOURCE_OPTIONS,
  CLEAR_LEAKS_TYPE_OPTIONS,
  SET_EMPLOYEES_LIST_OPTIONS,
  SET_EMPLOYEES,
  CLEAR_EMPLOYEES,
  SET_TECHNOLOGIES_LIST_OPTIONS,
  SET_TECHNOLOGIES,
  CLEAR_TECHNOLOGIES,
  SET_TLDS_WITH_NO_EMPLOYEES_SCAN,
  SET_TLDS_WITH_EMPLOYEES_SCAN,
  CLEAR_TLDS_WITH_NO_EMPLOYEES_SCAN,
  CLEAR_TLDS_WITH_EMPLOYEES_SCAN,
  CLEAR_PASSWORD_SPRAY_STATS_UPDATED,
  SET_PASSWORD_SPRAY_STATS_UPDATED,
  SET_CLOUD_INSTANCES_LIST_OPTIONS,
  SET_CLOUD_INSTANCES,
  CLEAR_CLOUD_INSTANCES,
  SET_CLOUD_INSTANCES_FULL_ITEMS,
  CLEAR_CLOUD_INSTANCES_FULL_ITEMS,
  SET_CLOUD_BUCKETS_LIST_OPTIONS,
  SET_CLOUD_BUCKETS,
  SET_CLOUD_BUCKETS_FULL_ITEMS,
  CLEAR_CLOUD_BUCKETS,
  CLEAR_CLOUD_BUCKETS_FULL_ITEMS,
  SET_SUBDOMAIN_TAGS_SUGGESTIONS,
  CLEAR_SUBDOMAIN_TAGS_SUGGESTIONS,
  SET_DOMAIN_TAGS_SUGGESTIONS,
  CLEAR_DOMAIN_TAGS_SUGGESTIONS,
  SET_LEAKS_LOADING,
  SET_INFRASTRUCTURE_LOADING,
  SET_TOP_LEVEL_DOMAINS_LOADING,
  SET_TECHNOLOGIES_LOADING,
  SET_EMPLOYEES_LOADING,
  SET_INFRASTRUCTURE_REF_ID,
  CLEAR_INFRASTRUCTURE_REF_ID,
  SET_EMPLOYEES_REF_ID,
  CLEAR_EMPLOYEES_REF_ID,
  CLEAR_TECHNOLOGIES_REF_ID,
  SET_TECHNOLOGIES_REF_ID,
  SET_CLOUD_BUCKETS_REF_ID,
  CLEAR_CLOUD_BUCKETS_REF_ID,
  SET_CLOUD_INSTANCES_REF_ID,
  CLEAR_CLOUD_INSTANCES_REF_ID,
  SET_CLOUD_INSTANCES_LOADING,
  SET_CLOUD_BUCKETS_LOADING,
  SET_TOP_LEVEL_DOMAINS_REF_ID,
  CLEAR_TOP_LEVEL_DOMAINS_REF_ID,
  SET_CLOUD_SERVICES_LOADING,
  SET_INFRASTRUCTURE_RUNNING_INTERVAL,
  SET_EMPLOYEES_RUNNING_INTERVAL,
  SET_TECHNOLOGIES_RUNNING_INTERVAL,
  SET_TLD_RUNNING_INTERVAL,
  SET_CLOUD_INSTANCES_RUNNING_INTERVAL,
  SET_CLOUD_BUCKETS_RUNNING_INTERVAL,
  SET_TOP_LEVEL_DOMAINS_OPTIONS,
  CLEAR_TOP_LEVEL_DOMAINS_OPTIONS,
  SET_EMPLOYEES_PROGRESS,
  CLEAR_EMPLOYEES_PROGRESS,
  SET_INFRASTRUCTURE_PROGRESS,
  CLEAR_INFRASTRUCTURE_PROGRESS,
  CLEAR_TECHNOLOGIES_PROGRESS,
  SET_TECHNOLOGIES_PROGRESS,
  SET_CLOUD_INSTANCES_PROGRESS,
  CLEAR_CLOUD_INSTANCES_PROGRESS,
  SET_CLOUD_BUCKETS_PROGRESS,
  CLEAR_CLOUD_BUCKETS_PROGRESS,
  SET_TOP_LEVEL_DOMAINS_PROGRESS,
  CLEAR_TOP_LEVEL_DOMAINS_PROGRESS,
  CLEAR_LEAKS_PROGRESS,
  SET_LEAKS_RUNNING_INTERVAL,
  SET_LEAKS_REF_ID,
  SET_LEAKS_PROGRESS,
  CLEAR_LEAKS_REF_ID,
  SET_RETRY_COUNTER,
  SET_INFOSTEALERS_LOADING,
  SET_INFOSTEALERS_RUNNING_INTERVAL,
  CLEAR_INFOSTEALERS_ITEMS,
  SET_INFOSTEALERS_REF_ID,
  SET_INFOSTEALERS_PROGRESS,
  CLEAR_INFOSTEALERS_REF_ID,
  CLEAR_INFOSTEALERS_PROGRESS,
  SET_INFOSTEALERS_ITEMS,
  SET_INFOSTEALERS_PAGINATION_STATE,
  SET_INFOSTEALERS_FILTERS,
  SET_INFOSTEALERS_PROGRESS_DATA,
  SET_INFOSTEALERS_LIST_OPTIONS,
  SET_INFOSTEALERS_POLLING_INTERVAL,
  SET_LAST_INFOSTEALERS_PROGRESS_CALL,
} from '@/store/configuration/mutationTypes';
import {
  SET_TOP_LEVEL_DOMAIN_PAGINATION_STATE,
  SET_INFRASTRUCTURE_PAGINATION_STATE,
  SET_LEAKS_PAGINATION_STATE,
  SET_EMPLOYEES_PAGINATION_STATE,
  SET_TECHNOLOGIES_PAGINATION_STATE,
  SET_CLOUD_INSTANCES_PAGINATION_STATE,
  SET_CLOUD_BUCKETS_PAGINATION_STATE,
} from '@/store/pagination/mutationTypes';
// eslint-disable-next-line import/no-cycle
import {
  loadInventoryDataByTab,
  loadPasswordSprayStatsUpdated,
  clearInfostealersCache,
  getInfostealersProgress,
} from '@/services/repository';
import { configuredKeywords } from '@/utils/infostealersProgress';

export default {
  async [types.RESET_SUCCESS_OPERATION_MESSAGE]({ commit }) {
    commit(SET_SUCCESS_OPERATION_MESSAGE, '');
  },
  async [types.TOGGLE_DOWNLOAD_REPORT_DISABLE]({ commit }, value) {
    commit(SET_DOWNLOAD_REPORT_DISABLE, value);
  },
  async [types.CHANGE_TOP_LEVEL_DOMAIN_LIST_OPTIONS]({ commit, dispatch, getters }, options) {
    const search = options.search === undefined ? getters.topLevelDomainListOptions.search : options.search;
    const filter = options.filter === undefined ? getters.topLevelDomainListOptions.filter : options.filter;
    const onlyValidated = options.onlyValidated === undefined ? getters.topLevelDomainListOptions.onlyValidated : options.onlyValidated;
    const has360 = options.has360 === undefined ? getters.topLevelDomainListOptions.has360 : options.has360;
    commit(SET_TOP_LEVEL_DOMAIN_LIST_OPTIONS, {
      sort: options.sort || getters.topLevelDomainListOptions.sort,
      limit: options.limit || getters.topLevelDomainListOptions.limit,
      page: options.page || getters.topLevelDomainListOptions.page,
      search,
      filter,
      onlyValidated,
      has360,
    });
    await dispatch(types.LOAD_TOP_LEVEL_DOMAINS, {
      sort: options.sort || getters.topLevelDomainListOptions.sort,
      limit: options.limit || getters.topLevelDomainListOptions.limit,
      page: options.page || getters.topLevelDomainListOptions.page,
      search,
      filter,
      onlyValidated,
      has360,
      turnOnLoading: options.turnOnLoading,
      domain: options?.domain || getters.domainFilter,
      organizations: options?.organizations || getters.organizationFilter,
      tab: options.tab,
      refId: options?.refId || '',
      selectAllFilters: options.selectAllFilters,
    });
  },
  async [types.LOAD_TOP_LEVEL_DOMAINS]({ commit, getters }, payload) {
    let result = {};
    try {
      if (payload.turnOnLoading) {
        if (!payload?.refId) {
          commit(CLEAR_TOP_LEVEL_DOMAINS_PROGRESS);
        }
        await commit(SET_TOP_LEVEL_DOMAINS_LOADING, true);
      }
      const toggles = {
        onlyValidated: payload.onlyValidated || getters.topLevelDomainListOptions.onlyValidated,
        has360: payload.has360 || getters.topLevelDomainListOptions.has360,
      };
      await commit(SET_TLD_RUNNING_INTERVAL, true);
      result = await loadInventoryDataByTab(
        {
          sort: payload.sort || getters.topLevelDomainListOptions.sort,
          limit: payload.limit || getters.topLevelDomainListOptions.limit,
          page: payload.page || getters.topLevelDomainListOptions.page,
          search: payload.search === undefined ? getters.topLevelDomainListOptions.search : payload.search,
          filter: payload.filter || getters.topLevelDomainListOptions.filter,
          toggles,
          domain: payload?.domain || getters.domainFilter,
          organizations: payload?.organizations || getters.organizationFilter,
          tab: payload.tab,
          selectAllFilters: payload?.selectAllFilters || null,
          refId: payload?.refId || '',
        },
      );
      await commit(SET_TLD_RUNNING_INTERVAL, false);
      if (result) {
        if (result?.refId) {
          if (result.refId !== getters.topLevelDomainsRefId) {
            commit(CLEAR_TOP_LEVEL_DOMAINS);
            commit(CLEAR_TOP_LEVEL_DOMAINS_ASSETS);
            commit(CLEAR_DOMAIN_TAGS_SUGGESTIONS);
            commit(SET_TOP_LEVEL_DOMAINS_REF_ID, result.refId);
          }
          if (result?.progress) {
            commit(SET_TOP_LEVEL_DOMAINS_PROGRESS, result.progress);
          }
        } else {
          await commit(SET_TOP_LEVEL_DOMAINS_PROGRESS, 100);
          await new Promise(r => setTimeout(r, 900));
          commit(CLEAR_TOP_LEVEL_DOMAINS_REF_ID);
          commit(CLEAR_TOP_LEVEL_DOMAINS_PROGRESS);
          const {
            items, page, pageCount, count, total, assets, tagsSuggestions, domainOptions,
          } = result;
          commit(SET_TOP_LEVEL_DOMAIN_PAGINATION_STATE, {
            page,
            pageCount,
            count,
            total,
          });
          if (items) {
            commit(SET_TOP_LEVEL_DOMAINS, items);
          }
          if (assets) {
            commit(SET_TOP_LEVEL_DOMAINS_ASSETS, assets);
          }
          if (domainOptions) {
            commit(SET_TOP_LEVEL_DOMAINS_OPTIONS, domainOptions);
          }
          if (tagsSuggestions) {
            commit(SET_DOMAIN_TAGS_SUGGESTIONS, tagsSuggestions);
          }
        }
      }
      const updatedRetryCounter = {
        ...getters.retryCounter,
        topLevelDomains: 0,
      };
      await commit(SET_RETRY_COUNTER, updatedRetryCounter);
    } catch (e) {
      if (getters.retryCounter.topLevelDomains > 5) {
        commit(CLEAR_TOP_LEVEL_DOMAINS);
        commit(CLEAR_TOP_LEVEL_DOMAINS_ASSETS);
        commit(CLEAR_TOP_LEVEL_DOMAINS_OPTIONS);
        commit(CLEAR_DOMAIN_TAGS_SUGGESTIONS);
        commit(CLEAR_TOP_LEVEL_DOMAINS_REF_ID);
        commit(CLEAR_TOP_LEVEL_DOMAINS_PROGRESS);
      } else {
        const updatedRetryCounter = {
          ...getters.retryCounter,
          topLevelDomains: getters.retryCounter.topLevelDomains + 1,
        };
        await commit(SET_RETRY_COUNTER, updatedRetryCounter);
      }
    } finally {
      if (!result?.refId) {
        await commit(SET_TOP_LEVEL_DOMAINS_LOADING, false);
      }
    }
  },
  async [types.UPDATE_SELECTED_TOP_LEVEL_DOMAINS]({ commit }, payload) {
    await commit(SET_TOP_LEVEL_DOMAINS, payload);
  },
  async [types.CHANGE_INFRASTRUCTURE_LIST_OPTIONS]({ commit, dispatch, getters }, options) {
    const search = options.search === undefined ? getters.infrastructureListOptions.search : options.search;
    const filter = options.filter === undefined ? getters.infrastructureListOptions.filter : options.filter;
    const hasPorts = options.hasPorts === undefined ? getters.infrastructureListOptions.hasPorts : options.hasPorts;
    const hasIssue = options.hasIssue === undefined ? getters.infrastructureListOptions.hasIssue : options.hasIssue;
    const hideUnresolved = options.hideUnresolved === undefined ? getters.infrastructureListOptions.hideUnresolved : options.hideUnresolved;
    const onlyNew = options.onlyNew === undefined ? getters.infrastructureListOptions.onlyNew : options.onlyNew;
    const onlyManual = options.onlyManual === undefined ? getters.infrastructureListOptions.onlyManual : options.onlyManual;
    commit(SET_INFRASTRUCTURE_LIST_OPTIONS, {
      sort: options.sort || getters.infrastructureListOptions.sort,
      limit: options.limit || getters.infrastructureListOptions.limit,
      page: options.page || getters.infrastructureListOptions.page,
      search,
      filter,
      hasPorts,
      hasIssue,
      hideUnresolved,
      onlyNew,
      onlyManual,
    });
    await dispatch(types.LOAD_INFRASTRUCTURE, {
      sort: options.sort || getters.infrastructureListOptions.sort,
      limit: options.limit || getters.infrastructureListOptions.limit,
      page: options.page || getters.infrastructureListOptions.page,
      search,
      filter,
      hasPorts,
      hasIssue,
      hideUnresolved,
      onlyNew,
      onlyManual,
      turnOnLoading: options.turnOnLoading,
      domain: options?.domain || getters.domainFilter,
      organizations: options?.organizations || getters.organizationFilter,
      tab: options.tab,
      refId: options?.refId || '',
      selectAllFilters: options?.selectAllFilters,
    });
  },
  async [types.LOAD_INFRASTRUCTURE]({ commit, getters }, payload) {
    let result = {};
    try {
      if (payload.turnOnLoading) {
        if (!payload?.refId) {
          commit(CLEAR_INFRASTRUCTURE_PROGRESS);
        }
        await commit(SET_INFRASTRUCTURE_LOADING, true);
      }
      const toggles = {
        hasPorts: payload.hasPorts || getters.infrastructureListOptions.hasPorts,
        hasIssue: payload.hasIssue || getters.infrastructureListOptions.hasIssue,
        hideUnresolved: payload.hideUnresolved || getters.infrastructureListOptions.hideUnresolved,
        onlyNew: payload.onlyNew || getters.infrastructureListOptions.onlyNew,
        onlyManual: payload.onlyManual || getters.infrastructureListOptions.onlyManual,
      };
      await commit(SET_INFRASTRUCTURE_RUNNING_INTERVAL, true);
      result = await loadInventoryDataByTab(
        {
          sort: payload.sort || getters.infrastructureListOptions.sort,
          limit: payload.limit || getters.infrastructureListOptions.limit,
          page: payload.page || getters.infrastructureListOptions.page,
          search: payload.search === undefined ? getters.infrastructureListOptions.search : payload.search,
          filter: payload.filter || getters.infrastructureListOptions.filter,
          toggles,
          domain: payload?.domain || getters.domainFilter,
          organizations: payload?.organizations || getters.organizationFilter,
          tab: payload.tab,
          refId: payload?.refId || '',
          selectAllFilters: payload?.selectAllFilters,
        },
      );
      await commit(SET_INFRASTRUCTURE_RUNNING_INTERVAL, false);
      if (result) {
        if (result?.refId) {
          if (result.refId !== getters.infrastructureRefId) {
            commit(CLEAR_INFRASTRUCTURE);
            commit(CLEAR_PORT_OPTIONS);
            commit(CLEAR_WAF_OPTIONS);
            commit(CLEAR_SERVICES_OPTIONS);
            commit(CLEAR_LOCATION_OPTIONS);
            commit(CLEAR_COORDINATES_OPTIONS);
            commit(CLEAR_SUBDOMAIN_TAGS_SUGGESTIONS);
            commit(SET_INFRASTRUCTURE_REF_ID, result.refId);
          }
          if (result?.progress) {
            commit(SET_INFRASTRUCTURE_PROGRESS, result.progress);
          }
        } else {
          await commit(SET_INFRASTRUCTURE_PROGRESS, 100);
          await new Promise(r => setTimeout(r, 900));
          commit(CLEAR_INFRASTRUCTURE_REF_ID);
          commit(CLEAR_INFRASTRUCTURE_PROGRESS);
          const {
            items, page, pageCount, count, total, portOptions, vendorOptions, serviceOptions, locations, coordinates, tagsSuggestions,
          } = result;
          commit(SET_INFRASTRUCTURE_PAGINATION_STATE, {
            page,
            pageCount,
            count,
            total,
          });
          if (items) {
            commit(SET_INFRASTRUCTURE, items);
          }
          if (portOptions) {
            commit(SET_PORT_OPTIONS, portOptions);
          }
          if (vendorOptions) {
            commit(SET_WAF_OPTIONS, vendorOptions);
          }
          if (serviceOptions) {
            commit(SET_SERVICES_OPTIONS, serviceOptions);
          }
          if (locations) {
            commit(SET_LOCATION_OPTIONS, locations);
          }
          if (coordinates) {
            commit(SET_COORDINATES_OPTIONS, coordinates);
          }
          if (tagsSuggestions) {
            commit(SET_SUBDOMAIN_TAGS_SUGGESTIONS, tagsSuggestions);
          }
        }
      }
      const updatedRetryCounter = {
        ...getters.retryCounter,
        infrastructure: 0,
      };
      await commit(SET_RETRY_COUNTER, updatedRetryCounter);
    } catch (e) {
      if (getters.retryCounter.infrastructure > 5) {
        commit(CLEAR_INFRASTRUCTURE);
        commit(CLEAR_PORT_OPTIONS);
        commit(CLEAR_WAF_OPTIONS);
        commit(CLEAR_SERVICES_OPTIONS);
        commit(CLEAR_LOCATION_OPTIONS);
        commit(CLEAR_COORDINATES_OPTIONS);
        commit(CLEAR_SUBDOMAIN_TAGS_SUGGESTIONS);
        commit(CLEAR_INFRASTRUCTURE_REF_ID);
        commit(CLEAR_INFRASTRUCTURE_PROGRESS);
      } else {
        const updatedRetryCounter = {
          ...getters.retryCounter,
          infrastructure: getters.retryCounter.infrastructure + 1,
        };
        await commit(SET_RETRY_COUNTER, updatedRetryCounter);
      }
    } finally {
      if (!result?.refId) {
        await commit(SET_INFRASTRUCTURE_LOADING, false);
      }
    }
  },
  async [types.UPDATE_SELECTED_INFRASTRUCTURE]({ commit }, payload) {
    await commit(SET_INFRASTRUCTURE, payload);
  },
  async [types.CHANGE_LEAKS_LIST_OPTIONS]({ commit, dispatch, getters }, options) {
    const search = options.search === undefined ? getters.leaksListOptions.search : options.search;
    const type = options.type === undefined ? getters.leaksListOptions.type : options.type;
    const source = options.source === undefined ? getters.leaksListOptions.source : options.source;
    const review = options.review === undefined ? getters.leaksListOptions.review : options.review;
    const important = options.important === undefined ? getters.leaksListOptions.important : options.important;
    commit(SET_LEAKS_LIST_OPTIONS, {
      sort: options.sort || getters.leaksListOptions.sort,
      limit: options.limit || getters.leaksListOptions.limit,
      page: options.page || getters.leaksListOptions.page,
      search,
      type,
      source,
      review,
      important,
    });
    await dispatch(types.LOAD_LEAKS, {
      sort: options.sort || getters.leaksListOptions.sort,
      limit: options.limit || getters.leaksListOptions.limit,
      page: options.page || getters.leaksListOptions.page,
      search,
      type,
      source,
      review,
      important,
      turnOnLoading: options.turnOnLoading,
      domain: options?.domain || getters.domainFilter,
      organizations: options?.organizations || getters.organizationFilter,
      tab: options.tab,
      refId: options?.refId || '',
    });
  },
  async [types.LOAD_LEAKS]({ commit, getters }, payload) {
    let result = {};
    try {
      if (payload.turnOnLoading) {
        if (!payload?.refId) {
          commit(CLEAR_LEAKS_PROGRESS);
        }
        await commit(SET_LEAKS_LOADING, true);
      }
      const toggles = {
        important: payload.important || getters.leaksListOptions.important,
      };
      const filter = {
        leakType: payload.type,
        source: payload.source,
        review: payload.review,
      };
      await commit(SET_LEAKS_RUNNING_INTERVAL, true);
      result = await loadInventoryDataByTab(
        {
          sort: payload.sort || getters.leaksListOptions.sort,
          limit: payload.limit || getters.leaksListOptions.limit,
          page: payload.page || getters.leaksListOptions.page,
          search: payload.search === undefined ? getters.leaksListOptions.search : payload.search,
          toggles,
          filter,
          domain: payload?.domain || getters.domainFilter,
          organizations: payload?.organizations || getters.organizationFilter,
          tab: payload.tab,
          refId: payload?.refId || '',
        },
      );
      await commit(SET_LEAKS_RUNNING_INTERVAL, false);
      if (result) {
        if (result?.refId) {
          if (result.refId !== getters.leaksRefId) {
            commit(CLEAR_LEAKS);
            commit(SET_LEAKS_REF_ID, result.refId);
          }
          if (result?.progress) {
            commit(SET_LEAKS_PROGRESS, result.progress);
          }
        } else {
          await commit(SET_LEAKS_PROGRESS, 100);
          await new Promise(r => setTimeout(r, 900));
          commit(CLEAR_LEAKS_REF_ID);
          commit(CLEAR_LEAKS_PROGRESS);
          const {
            items, page, pageCount, count, total, tldsWithNoLeaksScan, tldsWithLeaksScan, sourceOptions, typeOptions,
          } = result;
          commit(SET_LEAKS_PAGINATION_STATE, {
            page,
            pageCount,
            count,
            total,
          });
          if (items) {
            commit(SET_LEAKS, items);
          }
          if (tldsWithNoLeaksScan) {
            commit(SET_TLDS_WITH_NO_LEAKS_SCAN, tldsWithNoLeaksScan);
          }
          if (tldsWithLeaksScan) {
            commit(SET_TLDS_WITH_LEAKS_SCAN, tldsWithLeaksScan);
          }
          if (sourceOptions) {
            commit(SET_LEAKS_SOURCE_OPTIONS, sourceOptions);
          }
          if (typeOptions) {
            commit(SET_LEAKS_TYPE_OPTIONS, typeOptions);
          }
        }
      }
      const updatedRetryCounter = {
        ...getters.retryCounter,
        leaks: 0,
      };
      await commit(SET_RETRY_COUNTER, updatedRetryCounter);
    } catch (e) {
      if (getters.retryCounter.leaks > 5) {
        commit(CLEAR_LEAKS);
        commit(CLEAR_TLDS_WITH_NO_LEAKS_SCAN);
        commit(CLEAR_TLDS_WITH_LEAKS_SCAN);
        commit(CLEAR_LEAKS_SOURCE_OPTIONS);
        commit(CLEAR_LEAKS_TYPE_OPTIONS);
        commit(CLEAR_LEAKS_REF_ID);
        commit(CLEAR_LEAKS_PROGRESS);
      } else {
        const updatedRetryCounter = {
          ...getters.retryCounter,
          leaks: getters.retryCounter.leaks + 1,
        };
        await commit(SET_RETRY_COUNTER, updatedRetryCounter);
      }
    } finally {
      if (!result?.refId) {
        await commit(SET_LEAKS_LOADING, false);
      }
    }
  },
  async [types.UPDATE_DATA_LEAKS_ITEMS]({ commit }, payload) {
    await commit(SET_LEAKS, payload);
  },
  async [types.CHANGE_EMPLOYEES_LIST_OPTIONS]({ commit, dispatch, getters }, options) {
    const search = options.search === undefined ? getters.employeesListOptions.search : options.search;
    const filter = options.filter === undefined ? getters.employeesListOptions.filter : options.filter;
    const hasCredentials = options.hasCredentials === undefined ? getters.employeesListOptions.hasCredentials : options.hasCredentials;
    const authorized = options.authorized === undefined ? getters.employeesListOptions.authorized : options.authorized;
    commit(SET_EMPLOYEES_LIST_OPTIONS, {
      sort: options.sort || getters.employeesListOptions.sort,
      limit: options.limit || getters.employeesListOptions.limit,
      page: options.page || getters.employeesListOptions.page,
      search,
      filter,
      hasCredentials,
      authorized,
    });
    await dispatch(types.LOAD_EMPLOYEES, {
      sort: options.sort || getters.employeesListOptions.sort,
      limit: options.limit || getters.employeesListOptions.limit,
      page: options.page || getters.employeesListOptions.page,
      search,
      filter,
      hasCredentials,
      authorized,
      turnOnLoading: options.turnOnLoading,
      domain: options?.domain || getters.domainFilter,
      organizations: options?.organizations || getters.organizationFilter,
      tab: options.tab,
      refId: options?.refId || '',
      selectAllFilters: options.selectAllFilters,
    });
  },
  async [types.LOAD_EMPLOYEES]({ commit, getters }, payload) {
    let result = {};
    try {
      if (payload.turnOnLoading) {
        if (!payload?.refId) {
          commit(CLEAR_EMPLOYEES_PROGRESS);
        }
        await commit(SET_EMPLOYEES_LOADING, true);
      }
      const toggles = {
        hasCredentials: payload.hasCredentials || getters.employeesListOptions.hasCredentials,
        authorized: payload.authorized || getters.employeesListOptions.authorized,
      };
      await commit(SET_EMPLOYEES_RUNNING_INTERVAL, true);
      result = await loadInventoryDataByTab(
        {
          sort: payload.sort || getters.employeesListOptions.sort,
          limit: payload.limit || getters.employeesListOptions.limit,
          page: payload.page || getters.employeesListOptions.page,
          search: payload.search === undefined ? getters.employeesListOptions.search : payload.search,
          toggles,
          filter: payload.filter || getters.employeesListOptions.filter,
          domain: payload?.domain || getters.domainFilter,
          organizations: payload?.organizations || getters.organizationFilter,
          tab: payload.tab,
          refId: payload?.refId || '',
          selectAllFilters: payload?.selectAllFilters || null,
        },
      );
      await commit(SET_EMPLOYEES_RUNNING_INTERVAL, false);
      if (result) {
        if (result?.refId) {
          if (result.refId !== getters.employeesRefId) {
            if (payload.turnOnLoading) {
              commit(CLEAR_EMPLOYEES);
            }
            commit(SET_EMPLOYEES_REF_ID, result.refId);
          }
          if (result?.progress) {
            commit(SET_EMPLOYEES_PROGRESS, result.progress);
          }
        } else {
          await commit(SET_EMPLOYEES_PROGRESS, 100);
          await new Promise(r => setTimeout(r, 900));
          commit(CLEAR_EMPLOYEES_REF_ID);
          commit(CLEAR_EMPLOYEES_PROGRESS);
          const {
            items, page, pageCount, count, total, tldsWithNoEmployeesScan, tldsWithEmployeesScan,
          } = result;
          if (items) {
            commit(SET_EMPLOYEES, items);
          }
          if (tldsWithNoEmployeesScan) {
            commit(SET_TLDS_WITH_NO_EMPLOYEES_SCAN, tldsWithNoEmployeesScan);
          }
          if (tldsWithEmployeesScan) {
            commit(SET_TLDS_WITH_EMPLOYEES_SCAN, tldsWithEmployeesScan);
          }
          commit(SET_EMPLOYEES_PAGINATION_STATE, {
            page,
            pageCount,
            count,
            total,
          });
        }
      }
      const updatedRetryCounter = {
        ...getters.retryCounter,
        employees: 0,
      };
      await commit(SET_RETRY_COUNTER, updatedRetryCounter);
    } catch (e) {
      if (getters.retryCounter.employees > 5) {
        commit(CLEAR_EMPLOYEES);
        commit(CLEAR_TLDS_WITH_NO_EMPLOYEES_SCAN);
        commit(CLEAR_TLDS_WITH_EMPLOYEES_SCAN);
        commit(CLEAR_EMPLOYEES_REF_ID);
        commit(CLEAR_EMPLOYEES_PROGRESS);
      } else {
        const updatedRetryCounter = {
          ...getters.retryCounter,
          employees: getters.retryCounter.employees + 1,
        };
        await commit(SET_RETRY_COUNTER, updatedRetryCounter);
      }
    } finally {
      if (!result?.refId) {
        await commit(SET_EMPLOYEES_LOADING, false);
      }
    }
  },
  async [types.UPDATE_SELECTED_EMPLOYEES]({ commit }, payload) {
    await commit(SET_EMPLOYEES, payload);
  },
  async [types.CHANGE_TECHNOLOGIES_LIST_OPTIONS]({ commit, dispatch, getters }, options) {
    const search = options.search === undefined ? getters.technologiesListOptions.search : options.search;
    const filter = options.filter === undefined ? getters.technologiesListOptions.filter : options.filter;
    const hasExploit = options.hasExploit === undefined ? getters.technologiesListOptions.hasExploit : options.hasExploit;
    commit(SET_TECHNOLOGIES_LIST_OPTIONS, {
      sort: options.sort || getters.technologiesListOptions.sort,
      limit: options.limit || getters.technologiesListOptions.limit,
      page: options.page || getters.technologiesListOptions.page,
      search,
      filter,
      hasExploit,
    });
    await dispatch(types.LOAD_TECHNOLOGIES, {
      sort: options.sort || getters.technologiesListOptions.sort,
      limit: options.limit || getters.technologiesListOptions.limit,
      page: options.page || getters.technologiesListOptions.page,
      search,
      filter,
      hasExploit,
      turnOnLoading: options.turnOnLoading,
      domain: options?.domain || getters.domainFilter,
      organizations: options?.organizations || getters.organizationFilter,
      tab: options.tab,
      refId: options?.refId || '',
    });
  },
  async [types.LOAD_TECHNOLOGIES]({ commit, getters }, payload) {
    let result = {};
    try {
      if (payload.turnOnLoading) {
        if (!payload?.refId) {
          commit(CLEAR_TECHNOLOGIES_PROGRESS);
        }
        await commit(SET_TECHNOLOGIES_LOADING, true);
      }
      const toggles = {
        hasExploit: payload.hasExploit || getters.technologiesListOptions.hasExploit,
      };
      await commit(SET_TECHNOLOGIES_RUNNING_INTERVAL, true);
      result = await loadInventoryDataByTab(
        {
          sort: payload.sort || getters.technologiesListOptions.sort,
          limit: payload.limit || getters.technologiesListOptions.limit,
          page: payload.page || getters.technologiesListOptions.page,
          search: payload.search === undefined ? getters.technologiesListOptions.search : payload.search,
          toggles,
          filter: payload.filter || getters.technologiesListOptions.filter,
          domain: payload?.domain || getters.domainFilter,
          organizations: payload?.organizations || getters.organizationFilter,
          tab: payload.tab,
          refId: payload?.refId || '',
        },
      );
      await commit(SET_TECHNOLOGIES_RUNNING_INTERVAL, false);
      if (result) {
        if (result?.refId) {
          if (result.refId !== getters.technologiesRefId) {
            commit(CLEAR_TECHNOLOGIES);
            commit(SET_TECHNOLOGIES_REF_ID, result.refId);
          }
          if (result?.progress) {
            commit(SET_TECHNOLOGIES_PROGRESS, result.progress);
          }
        } else {
          await commit(SET_TECHNOLOGIES_PROGRESS, 100);
          await new Promise(r => setTimeout(r, 900));
          commit(CLEAR_TECHNOLOGIES_REF_ID);
          commit(CLEAR_TECHNOLOGIES_PROGRESS);
          const {
            items, page, pageCount, count, total,
          } = result;
          commit(SET_TECHNOLOGIES_PAGINATION_STATE, {
            page,
            pageCount,
            count,
            total,
          });
          if (items) {
            commit(SET_TECHNOLOGIES, items);
          }
        }
      }
      const updatedRetryCounter = {
        ...getters.retryCounter,
        technologies: 0,
      };
      await commit(SET_RETRY_COUNTER, updatedRetryCounter);
    } catch (e) {
      if (getters.retryCounter.technologies > 5) {
        commit(CLEAR_TECHNOLOGIES);
        commit(CLEAR_TECHNOLOGIES_REF_ID);
        commit(CLEAR_TECHNOLOGIES_PROGRESS);
      } else {
        const updatedRetryCounter = {
          ...getters.retryCounter,
          technologies: getters.retryCounter.technologies + 1,
        };
        await commit(SET_RETRY_COUNTER, updatedRetryCounter);
      }
    } finally {
      if (!result?.refId) {
        await commit(SET_TECHNOLOGIES_LOADING, false);
      }
    }
  },
  async [types.LOAD_PASSWORD_SPRAY_STATS_UPDATED]({ commit }, options) {
    try {
      const result = await loadPasswordSprayStatsUpdated(options);
      commit(SET_PASSWORD_SPRAY_STATS_UPDATED, result);
    } catch (e) {
      commit(CLEAR_PASSWORD_SPRAY_STATS_UPDATED);
    }
  },
  async [types.CHANGE_CLOUD_INSTANCES_LIST_OPTIONS]({ commit, dispatch, getters }, options) {
    const search = options.search === undefined ? getters.cloudInstancesListOptions.search : options.search;
    const filter = options.filter === undefined ? getters.cloudInstancesListOptions.filter : options.filter;
    const exposed = options.exposed === undefined ? getters.cloudInstancesListOptions.exposed : options.exposed;
    const showSuppress = options.showSuppress === undefined ? getters.cloudInstancesListOptions.showSuppress : options.showSuppress;
    commit(SET_CLOUD_INSTANCES_LIST_OPTIONS, {
      sort: options.sort || getters.cloudInstancesListOptions.sort,
      limit: options.limit || getters.cloudInstancesListOptions.limit,
      page: options.page || getters.cloudInstancesListOptions.page,
      search,
      filter,
      exposed,
      showSuppress,
    });
    await dispatch(types.LOAD_CLOUD_INSTANCES, {
      sort: options.sort || getters.cloudInstancesListOptions.sort,
      limit: options.limit || getters.cloudInstancesListOptions.limit,
      page: options.page || getters.cloudInstancesListOptions.page,
      search,
      filter,
      exposed,
      showSuppress,
      turnOnLoading: options.turnOnLoading,
      domain: options?.domain || getters.domainFilter,
      organizations: options?.organizations || getters.organizationFilter,
      tab: options.tab,
      refId: options?.refId || '',
      selectAllFilters: options.selectAllFilters,
    });
  },
  async [types.LOAD_CLOUD_INSTANCES]({ commit, getters }, payload) {
    let result = {};
    try {
      if (payload.turnOnLoading) {
        if (!payload?.refId) {
          commit(CLEAR_CLOUD_INSTANCES_PROGRESS);
        }
        await commit(SET_CLOUD_INSTANCES_LOADING, true);
      }
      const toggles = {
        exposed: payload.exposed || getters.cloudInstancesListOptions.exposed,
        showSuppress: payload.showSuppress || getters.cloudInstancesListOptions.showSuppress,
      };
      await commit(SET_CLOUD_INSTANCES_RUNNING_INTERVAL, true);
      result = await loadInventoryDataByTab(
        {
          sort: payload.sort || getters.cloudInstancesListOptions.sort,
          limit: payload.limit || getters.cloudInstancesListOptions.limit,
          page: payload.page || getters.cloudInstancesListOptions.page,
          search: payload.search === undefined ? getters.cloudInstancesListOptions.search : payload.search,
          toggles,
          filter: payload.filter || getters.cloudInstancesListOptions.filter,
          domain: payload?.domain || getters.domainFilter,
          organizations: payload?.organizations || getters.organizationFilter,
          tab: payload.tab,
          refId: payload?.refId || '',
          selectAllFilters: payload?.selectAllFilters || null,
        },
      );
      await commit(SET_CLOUD_INSTANCES_RUNNING_INTERVAL, false);
      if (result) {
        if (result?.refId) {
          if (result.refId !== getters.cloudInstancesRefId) {
            commit(CLEAR_CLOUD_INSTANCES);
            commit(SET_CLOUD_INSTANCES_REF_ID, result.refId);
          }
          if (result?.progress) {
            commit(SET_CLOUD_INSTANCES_PROGRESS, result.progress);
          }
        } else {
          await commit(SET_CLOUD_INSTANCES_PROGRESS, 100);
          await new Promise(r => setTimeout(r, 900));
          commit(CLEAR_CLOUD_INSTANCES_REF_ID);
          commit(CLEAR_CLOUD_INSTANCES_PROGRESS);
          const {
            items, page, pageCount, count, total, fullItems,
          } = result;
          commit(SET_CLOUD_INSTANCES_PAGINATION_STATE, {
            page,
            pageCount,
            count,
            total,
          });
          if (items) {
            commit(SET_CLOUD_INSTANCES, items);
          }
          if (fullItems) {
            commit(SET_CLOUD_INSTANCES_FULL_ITEMS, fullItems);
          }
        }
      }
      const updatedRetryCounter = {
        ...getters.retryCounter,
        cloudInstances: 0,
      };
      await commit(SET_RETRY_COUNTER, updatedRetryCounter);
    } catch (e) {
      if (getters.retryCounter.cloudInstances > 5) {
        commit(CLEAR_CLOUD_INSTANCES);
        commit(CLEAR_CLOUD_INSTANCES_FULL_ITEMS);
        commit(CLEAR_CLOUD_INSTANCES_REF_ID);
        commit(CLEAR_CLOUD_INSTANCES_PROGRESS);
      } else {
        const updatedRetryCounter = {
          ...getters.retryCounter,
          cloudInstances: getters.retryCounter.cloudInstances + 1,
        };
        await commit(SET_RETRY_COUNTER, updatedRetryCounter);
      }
    } finally {
      if (!result?.refId) {
        await commit(SET_CLOUD_INSTANCES_LOADING, false);
      }
    }
  },
  async [types.UPDATE_SELECTED_CLOUD_INSTANCES]({ commit }, payload) {
    await commit(SET_CLOUD_INSTANCES, payload);
  },
  async [types.CHANGE_CLOUD_BUCKETS_LIST_OPTIONS]({ commit, dispatch, getters }, options) {
    const search = options.search === undefined ? getters.cloudBucketsListOptions.search : options.search;
    const filter = options.filter === undefined ? getters.cloudBucketsListOptions.filter : options.filter;
    const exposed = options.exposed === undefined ? getters.cloudBucketsListOptions.exposed : options.exposed;
    const showSuppress = options.showSuppress === undefined ? getters.cloudBucketsListOptions.showSuppress : options.showSuppress;
    commit(SET_CLOUD_BUCKETS_LIST_OPTIONS, {
      sort: options.sort || getters.cloudBucketsListOptions.sort,
      limit: options.limit || getters.cloudBucketsListOptions.limit,
      page: options.page || getters.cloudBucketsListOptions.page,
      search,
      filter,
      exposed,
      showSuppress,
    });
    await dispatch(types.LOAD_CLOUD_BUCKETS, {
      sort: options.sort || getters.cloudBucketsListOptions.sort,
      limit: options.limit || getters.cloudBucketsListOptions.limit,
      page: options.page || getters.cloudBucketsListOptions.page,
      search,
      filter,
      exposed,
      showSuppress,
      turnOnLoading: options.turnOnLoading,
      domain: options?.domain || getters.domainFilter,
      organizations: options?.organizations || getters.organizationFilter,
      tab: options.tab,
      refId: options?.refId || '',
      selectAllFilters: options.selectAllFilters,
    });
  },
  async [types.LOAD_CLOUD_BUCKETS]({ commit, getters }, payload) {
    let result = {};
    try {
      if (payload.turnOnLoading) {
        if (!payload?.refId) {
          commit(CLEAR_CLOUD_BUCKETS_PROGRESS);
        }
        await commit(SET_CLOUD_BUCKETS_LOADING, true);
      }
      const toggles = {
        exposed: payload.exposed || getters.cloudBucketsListOptions.exposed,
        showSuppress: payload.showSuppress || getters.cloudBucketsListOptions.showSuppress,
      };
      await commit(SET_CLOUD_BUCKETS_RUNNING_INTERVAL, true);
      result = await loadInventoryDataByTab(
        {
          sort: payload.sort || getters.cloudBucketsListOptions.sort,
          limit: payload.limit || getters.cloudBucketsListOptions.limit,
          page: payload.page || getters.cloudBucketsListOptions.page,
          search: payload.search === undefined ? getters.cloudBucketsListOptions.search : payload.search,
          toggles,
          filter: payload.filter || getters.cloudBucketsListOptions.filter,
          domain: payload?.domain || getters.domainFilter,
          organizations: payload?.organizations || getters.organizationFilter,
          tab: payload.tab,
          refId: payload?.refId || '',
          selectAllFilters: payload?.selectAllFilters || null,
        },
      );
      await commit(SET_CLOUD_BUCKETS_RUNNING_INTERVAL, false);
      if (result) {
        if (result?.refId) {
          if (result.refId !== getters.cloudBucketsRefId) {
            commit(CLEAR_CLOUD_BUCKETS);
            commit(SET_CLOUD_BUCKETS_REF_ID, result.refId);
          }
          if (result?.progress) {
            commit(SET_CLOUD_BUCKETS_PROGRESS, result.progress);
          }
        } else {
          await commit(SET_CLOUD_BUCKETS_PROGRESS, 100);
          await new Promise(r => setTimeout(r, 900));
          commit(CLEAR_CLOUD_BUCKETS_REF_ID);
          commit(CLEAR_CLOUD_BUCKETS_PROGRESS);
          const {
            items, page, pageCount, count, total, fullItems,
          } = result;
          commit(SET_CLOUD_BUCKETS_PAGINATION_STATE, {
            page,
            pageCount,
            count,
            total,
          });
          if (items) {
            commit(SET_CLOUD_BUCKETS, items);
          }
          if (fullItems) {
            commit(SET_CLOUD_BUCKETS_FULL_ITEMS, fullItems);
          }
        }
      }
      const updatedRetryCounter = {
        ...getters.retryCounter,
        cloudBuckets: 0,
      };
      await commit(SET_RETRY_COUNTER, updatedRetryCounter);
    } catch (e) {
      if (getters.retryCounter.cloudBuckets > 5) {
        commit(CLEAR_CLOUD_BUCKETS);
        commit(CLEAR_CLOUD_BUCKETS_FULL_ITEMS);
        commit(CLEAR_CLOUD_BUCKETS_REF_ID);
        commit(CLEAR_CLOUD_BUCKETS_PROGRESS);
      } else {
        const updatedRetryCounter = {
          ...getters.retryCounter,
          cloudBuckets: getters.retryCounter.cloudBuckets + 1,
        };
        await commit(SET_RETRY_COUNTER, updatedRetryCounter);
      }
    } finally {
      if (!result?.refId) {
        await commit(SET_CLOUD_BUCKETS_LOADING, false);
      }
    }
  },
  async [types.UPDATE_SELECTED_CLOUD_BUCKETS]({ commit }, payload) {
    await commit(SET_CLOUD_BUCKETS, payload);
  },
  async [types.SET_CLOUD_INSTANCES_LOADING]({ commit }, payload) {
    await commit(SET_CLOUD_INSTANCES_LOADING, payload);
  },
  async [types.SET_CLOUD_BUCKETS_LOADING]({ commit }, payload) {
    await commit(SET_CLOUD_BUCKETS_LOADING, payload);
  },
  async [types.SET_CLOUD_SERVICES_LOADING]({ commit }, payload) {
    await commit(SET_CLOUD_SERVICES_LOADING, payload);
  },
  async [types.CHANGE_INFOSTEALERS_LIST_OPTIONS]({ commit, dispatch, getters }, options) {
    const search = options.search === undefined ? getters.infostealersListOptions.search : options.search;
    const filter = options.filter || getters.infostealersListOptions.filter;
    const hasExploit = options.hasExploit === undefined ? getters.infostealersListOptions.hasExploit : options.hasExploit;
    await commit(SET_INFOSTEALERS_LIST_OPTIONS, {
      sort: options.sort || getters.infostealersListOptions.sort,
      limit: options.limit || getters.infostealersListOptions.limit,
      page: options.page || getters.infostealersListOptions.page,
      filters: options.filters || getters.infostealersListOptions.filters,
      search,
      filter,
      hasExploit,
    });
    await dispatch(types.LOAD_INFOSTEALERS, {
      sort: options.sort || getters.infostealersListOptions.sort,
      limit: options.limit || getters.infostealersListOptions.limit,
      page: options.page || getters.infostealersListOptions.page,
      search,
      filter,
      filters: options.filters || getters.infostealersListOptions.filters,
      hasExploit,
      turnOnLoading: options.turnOnLoading,
      domain: options?.domain || getters.domainFilter,
      organizations: options?.organizations || getters.organizationFilter,
      tab: 'infostealers',
      refId: options?.refId || '',
    });
  },

  async [types.LOAD_INFOSTEALERS]({ commit, getters }, payload) {
    let hasRefId = false;
    try {
      const safePayload = payload || {};
      await commit(SET_INFOSTEALERS_LOADING, true);
      await commit(SET_INFOSTEALERS_RUNNING_INTERVAL, true);
      const requestParams = {
        sort: safePayload.sort || (getters.infostealersListOptions?.sort || {}),
        limit: safePayload.limit || (getters.infostealersListOptions?.limit || 20),
        page: safePayload.page || (getters.infostealersListOptions?.page || 1),
        search: safePayload.search === undefined ? (getters.infostealersListOptions?.search || '') : safePayload.search,
        filter: safePayload.filter || (getters.infostealersListOptions?.filter || ''),
        filters: safePayload.filters || (getters.infostealersListOptions?.filters || {}),
        domain: safePayload?.domain || getters.domainFilter,
        organizations: safePayload?.organizations || getters.organizationFilter,
        tab: safePayload.tab || 'infostealers',
        toggles: {},
        refId: safePayload?.refId || undefined,
      };
      let response = await loadInventoryDataByTab(requestParams);
      await commit(SET_INFOSTEALERS_RUNNING_INTERVAL, false);
      if (response) {
        if (response?.refId) {
          hasRefId = true;
          if (response.refId !== getters.infostealersRefId) {
            commit(CLEAR_INFOSTEALERS_ITEMS);
            commit(SET_INFOSTEALERS_REF_ID, response.refId);
            // New scan session: reset so progress can start low.
            commit(CLEAR_INFOSTEALERS_PROGRESS);
          }
          if (response?.progress) {
            // Monotonic: never let the loader bar move backwards within a session.
            const nextProgress = Math.max(getters.infostealersProgress || 0, response.progress);
            commit(SET_INFOSTEALERS_PROGRESS, nextProgress);
          }
        } else {
          await commit(SET_INFOSTEALERS_PROGRESS, 100);
          await new Promise(r => setTimeout(r, 900));
          commit(CLEAR_INFOSTEALERS_REF_ID);
          commit(CLEAR_INFOSTEALERS_PROGRESS);
          // Deep clone items to prevent memory retention
          let clonedItems = response.items.map(item => ({
            ...item,
            cookies: item.cookies ? item.cookies.map(cookie => ({ ...cookie })) : [],
            passwords: item.passwords ? item.passwords.map(password => ({ ...password })) : [],
            system: item.system ? { ...item.system } : {},
          }));

          await commit(SET_INFOSTEALERS_ITEMS, clonedItems);
          clonedItems = [];
          response.items = [];
          await commit(SET_INFOSTEALERS_PAGINATION_STATE, {
            page: response.current_page,
            itemsPerPage: getters.infostealersListOptions?.limit || 20,
            total: response.total_items,
            hasNext: response.has_next,
            hasPrevious: response.has_previous,
            totalPages: response.total_pages,
          });

          // Explicit shallow copy for filter lists
          const currentFilters = getters.infostealersFilters;
          await commit(SET_INFOSTEALERS_FILTERS, {
            countryList: [...(response.countryList || [])],
            hostnamesList: [...(response.hostnamesList || [])],
            ipList: [...(response.ipList || [])],
            osList: [...(response.osList || [])],
            usernamesList: [...(response.usernamesList || [])],
            infostealersList: [...(response.infostealersList || [])],
            keywordsList: currentFilters.keywordsList && currentFilters.keywordsList.length > 0
              ? currentFilters.keywordsList
              : [...(response.keywordsList || [])],
          });
          response = undefined;
        }
      }
    } catch (error) {
      console.error('Error loading infostealers:', error);
      await commit(SET_INFOSTEALERS_RUNNING_INTERVAL, false);
      await commit(CLEAR_INFOSTEALERS_REF_ID);
      await commit(CLEAR_INFOSTEALERS_PROGRESS);
      await commit(SET_INFOSTEALERS_LOADING, false);
    } finally {
      if (!hasRefId) {
        await commit(SET_INFOSTEALERS_LOADING, false);
      }
    }
  },

  async [types.CLEAR_INFOSTEALERS_ITEMS]({ commit }) {
    commit(CLEAR_INFOSTEALERS_ITEMS);
  },

  async [types.CLEAR_INFOSTEALERS_CACHE]({ commit }) {
    try {
      commit(CLEAR_INFOSTEALERS_ITEMS);
      commit(CLEAR_INFOSTEALERS_REF_ID);
      commit(CLEAR_INFOSTEALERS_PROGRESS);
    } catch (error) {
      console.error('Error clearing infostealers cache:', error);
    }
  },

  async [types.CLEAR_INFOSTEALERS_BACKEND_CACHE]() {
    try {
      await clearInfostealersCache();
    } catch (error) {
      console.error('Error clearing infostealers backend cache:', error);
    }
  },

  async [types.CLEAR_TOP_LEVEL_DOMAINS_CACHE]({ commit }) {
    try {
      commit(CLEAR_TOP_LEVEL_DOMAINS);
      commit(CLEAR_TOP_LEVEL_DOMAINS_ASSETS);
      commit(CLEAR_TOP_LEVEL_DOMAINS_OPTIONS);
      commit(CLEAR_DOMAIN_TAGS_SUGGESTIONS);
      commit(CLEAR_TOP_LEVEL_DOMAINS_REF_ID);
      commit(CLEAR_TOP_LEVEL_DOMAINS_PROGRESS);
    } catch (error) {
      console.error('Error clearing top level domains cache:', error);
    }
  },

  async [types.LOAD_INFOSTEALERS_PROGRESS]({ commit, state, rootGetters }) {
    // Check if infostealers module is licensed
    const isBrandProtectionEnabled = rootGetters.hasLicenseModule?.('infostealers') || false;
    if (!isBrandProtectionEnabled) {
      const defaultResponse = {
        running_jobs: [],
        total_running: 0,
      };
      commit(SET_INFOSTEALERS_PROGRESS_DATA, defaultResponse);
      return defaultResponse;
    }

    // Prevent duplicate calls within a short time window
    const now = Date.now();
    if (state.lastInfostealersProgressCall && (now - state.lastInfostealersProgressCall) < 1000) {
      return state.infostealersProgressData;
    }

    try {
      const response = await getInfostealersProgress();
      commit(SET_INFOSTEALERS_PROGRESS_DATA, response);
      // Update the last call timestamp
      commit(SET_LAST_INFOSTEALERS_PROGRESS_CALL, now);
      return response;
    } catch (error) {
      console.error('Error loading infostealers progress:', error);
      const defaultResponse = {
        running_jobs: [],
        total_running: 0,
      };
      commit(SET_INFOSTEALERS_PROGRESS_DATA, defaultResponse);
      return defaultResponse;
    }
  },

  async [types.START_INFOSTEALERS_POLLING]({
    commit, state, dispatch, rootGetters, rootState,
  }) {
    // Check if infostealers module is licensed
    const isBrandProtectionEnabled = rootGetters.hasLicenseModule?.('infostealers') || false;
    if (!isBrandProtectionEnabled) {
      return;
    }

    if (state.infostealersPollingInterval) {
      clearInterval(state.infostealersPollingInterval);
      commit(SET_INFOSTEALERS_POLLING_INTERVAL, null);
    }

    await dispatch(types.LOAD_INFOSTEALERS_PROGRESS);

    setTimeout(() => {
      const interval = setInterval(async () => {
        const response = await dispatch(types.LOAD_INFOSTEALERS_PROGRESS);

        // Union of legacy keywordsList + new keywordsBySource.platform.
        const currentKeywords = [...configuredKeywords(rootState.user.systemSettings?.settingsMetaData?.brandProtection)];

        // Stop refreshing once nothing is actively in flight. Completed jobs stay
        // in the response (so the widget keeps showing their final status), so we
        // must gate on running/pending state, not on presence of any job.
        const activeJobs = response.running_jobs?.filter(
          job => currentKeywords.includes(job.keyword) && ['pending', 'running'].includes(job.status),
        ) || [];

        if (activeJobs.length === 0) {
          clearInterval(interval);
          commit(SET_INFOSTEALERS_POLLING_INTERVAL, null);
        }
      }, 10000);
      commit(SET_INFOSTEALERS_POLLING_INTERVAL, interval);
    }, 3000);
  },

  async [types.STOP_INFOSTEALERS_POLLING]({ commit, state }) {
    if (state.infostealersPollingInterval) {
      clearInterval(state.infostealersPollingInterval);
      commit(SET_INFOSTEALERS_POLLING_INTERVAL, null);
    }
  },
};
